import React, { Component } from 'react';
import FaCheck from 'react-icons/lib/fa/check';

import recommendIcon from '../../../assets/image/recommend.svg';

class SelectItemVertical extends Component {
  // state = { hover: false };

  toggleHover = () => {
    this.setState({hover: !this.state.hover})
  };

  handleClick = () => {
    const { disable, onClick } = this.props;
    if (!disable) {
      onClick();
    }
  }

  render() {
    const iconStyle = {
      color: 'black',
    };

    const checkIcon = this.props.active ? <FaCheck style={iconStyle} /> : null;
    // eslint-disable-next-line
    const checkBox = this.props.check ? (
      <div className="CheckBox" >{checkIcon}</div>
    ) : null;

    let className = this.props.active ? 'SelectItemVerticalWrapper BoxShadow SelectItemActive' : 'SelectItemVerticalWrapper BoxShadow SelectItem';
    if (this.props.disable) {
      className = this.props.active ? 'SelectItemVerticalWrapper SelectItemDisableActive' : 'SelectItemVerticalWrapper SelectItemDisable';
    }

    const recomend = this.props.recomend ? <img src={recommendIcon} className="RecommendationLogo" alt="charactor" /> : null;

    return (
      <div
        className={className}
        onClick={this.handleClick}
      >
        {recomend}
        <div className="SelectorItemVertical" >
          {recomend}
          <div className="SelectorItemVerticalTitle" >{this.props.title}</div>
          <div className="SelectorItemVerticalDesc" >{this.props.desc}</div>
        </div>
      </div>
    );
  };
};

export default SelectItemVertical;
